import { Flex,
  Box,
  Text,
  Badge,
 } from "@chakra-ui/react";
import { CalendarX, CalendarX2, FileX2, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const MonitoringWidget = () => {
  


  return (
    <Flex 
      direction={"column"} 
      gap={{ lg: 8, base: 4 }}
      >

   <Flex
      justifyContent="flex-start"
      w={{ lg: "fit-content", base: "100%" }}
      gap={{ lg: 16, base: 8 }}
      sx={{
        ".kpi": {
          display: "flex",
          flexDirection: "row",
          gap: 4,
          w: "fit-content",
          flex: { lg: 1, base: "none" }, // Correction ici
          alignItems: "center",
        },
        span: {
          w: "fit-content",
        },
        ".icon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          w: { lg: "42px", base: "36px" },
          h: { lg: "42px", base: "36px" },
          borderRadius: 8,
          p: 1,
          bg: "grey.700",
          overflow: "hidden",
        },
        ".icon .lucide": {
          color: "white",
        },
      }}>
      
      <Link className="kpi" to="/monitoring/screening">
        <Box className="icon" bg={"error.700 !important"}>
          <ShieldCheck size={24} />
        </Box>
        <Flex direction={"column"}>
        <Text display={{ lg: "block", base: "none" }} whiteSpace={"nowrap"}>KYC hits</Text>
          <Badge fontSize="lg" colorScheme="error">
              11
          </Badge>
        </Flex>
      </Link>


      <Link className="kpi" to="/monitoring/documents">
        <Box className="icon" bg={"error.700 !important"}>
            <CalendarX2 size={24} />
        </Box>
        <Flex direction={"column"}>
        <Text display={{ lg: "block", base: "none" }} whiteSpace={"nowrap"}>Expired docs</Text>
          <Badge fontSize="lg" colorScheme="error">
              5
          </Badge>
        </Flex>
      </Link>
 

      <Link className="kpi" to="/monitoring/documents">
        <Box className="icon" bg={"error.700 !important"}>
          <FileX2 size={24} />
        </Box>
        <Flex direction={"column"}>
          <Text display={{ lg: "block", base: "none" }} whiteSpace={"nowrap"}>Missing docs</Text>
          <Badge fontSize="lg" colorScheme="error">
              5
          </Badge>
        </Flex>
      </Link>

      <Link className="kpi" as={Flex} to="/reporting/overview">
        <Box className="icon" bg={"error.700 !important"}>
          <CalendarX size={24} />
        </Box>
        <Flex direction={"column"}>
          <Text display={{ lg: "block", base: "none" }} whiteSpace={"nowrap"}>Reports overdue</Text>
          <Badge fontSize="lg" colorScheme="error">
              8
          </Badge>
        </Flex>
      </Link>

     

</Flex>
        
      </Flex>

      
   
    
  );
};

export default MonitoringWidget;
